export interface UsersData {
    version: string
    id: string
    result: {
        users: User[]
        permissions: {
            doorOpener : boolean
            globalSearch: boolean
            infoModule: boolean
            digitalLicenses: boolean
        }
    }
}

export class UsersData implements UsersData {
    constructor(version: string = "", id: string = "", users: User[] = [])
    {
        this.version = version
        this.id = id
        this.result = {users: users, permissions: {doorOpener: false, globalSearch: false, infoModule: false, digitalLicenses: false}}
    }
}

export interface User {
    id: number
    username: string
    name: string
    email: string
    title: string
    phone: string
    password: string

    active: boolean

    permissionAlarms: boolean
    permissionDoorOpener: boolean
    permissionGlobalSearch: boolean
    permissionInfoModule: boolean
    permissionMobileBase: boolean
    permissionStatistics: boolean
    permissionUserManagement: boolean
    permissionDigitalLicenses: boolean

    locationsAccess: number[]
}

export class User implements User {
    constructor(id: number = 0, username: string = "", name: string = "", email: string = "", title: string = "", phone: string = "", password: string = "", active: boolean = true,
        permissionAlarms: boolean = false, permissionDoorOpener: boolean = false, permissionGlobalSearch: boolean = false, permissionInfoModule: boolean = false,
        permissionMobileBase: boolean = false, permissionStatistics: boolean = false, permissionUserManagement: boolean = false, permissionDigitalLicenses: boolean = false,
        locationsAccess: number[] = [])
    {
        this.id = id
        this.username = username
        this.name = name
        this.email = email
        this.title = title
        this.phone = phone
        this.password = password

        this.active = active

        this.permissionAlarms = permissionAlarms
        this.permissionDoorOpener = permissionDoorOpener
        this.permissionGlobalSearch = permissionGlobalSearch
        this.permissionInfoModule = permissionInfoModule
        this.permissionMobileBase = permissionMobileBase
        this.permissionStatistics = permissionStatistics
        this.permissionUserManagement = permissionUserManagement
        this.permissionDigitalLicenses = permissionDigitalLicenses

        this.locationsAccess = locationsAccess
    }
}

export interface StoreParams {
    body: {
        name: string
        username: string
        email: string
        title: string
        phone: string
        password: string

        active: boolean

        permissionAlarms: boolean
        permissionDoorOpener: boolean
        permissionGlobalSearch: boolean
        permissionInfoModule: boolean
        permissionMobileBase: boolean
        permissionStatistics: boolean
        permissionUserManagement: boolean
        permissionDigitalLicenses: boolean

        locationsAccess: number[]
    }
}

export class StoreParams implements StoreParams {
    constructor(username: string, name: string, email: string, title: string, phone: string, password: string, active: boolean,
        permissionAlarms: boolean, permissionDoorOpener: boolean, permissionGlobalSearch: boolean, permissionInfoModule: boolean,
        permissionMobileBase: boolean, permissionStatistics: boolean, permissionUserManagement: boolean, permissionDigitalLicenses: boolean, locationsAccess: number[])
    {
        this.body = {username: username, name: name, email: email, title: title, phone: phone, password: password, active: active, permissionAlarms: permissionAlarms, permissionDoorOpener: permissionDoorOpener,
            permissionGlobalSearch: permissionGlobalSearch, permissionInfoModule: permissionInfoModule, permissionMobileBase: permissionMobileBase, permissionStatistics: permissionStatistics,
            permissionUserManagement: permissionUserManagement, permissionDigitalLicenses: permissionDigitalLicenses, locationsAccess}
    }
}

export interface UserLocationData {
    locationId: number
    locationName: string
    userIDList: number[]
    userNamesList: string[]
    userNames: string
}

export interface UserLocations {
    version: string
    id: string
    result: UserLocationData[]
}

export interface StoreUserLocationParams {
    locationId: number
    userAccess: number[]
}
